
import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, InputGroup } from "reactstrap";

import { useController, useForm } from "react-hook-form";
import{updateWallet,getWallet} from "../../../Services/Driver.service"
import DatePicker from "react-datepicker";
import { showAlert } from "../../../Services/Shared.service";
import Select from "react-select";
import SharedDataContext from "../../../_helper/SharedData";

// ---------------------------------------
const DriverSchemeMinimumEdit = ({obj,isModal,closeModal,triggerRefresh}) => {
  const [data, setdata] = useState({})
  const { cityData, setTabValue } = useContext(SharedDataContext);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {},
  });
const { ServiceCity, DriverType } = watch();
const { minBalance, applicableFromDate, applicableToDate, applicableTo } = watch();



  const applicableToDateField = useController({
    name: "applicableToDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable To Date is Required",
      },
    },
  }).field;
  
  const handleApplicableToDate = (data) => {
    console.log("handleApplicableToDate", data);
    applicableToDateField.onChange(data);
  };

  const applicableFromDateField = useController({
    name: "applicableFromDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable From Date is Required",
      },
    },
  }).field;

  const handleApplicableFromDate = (data) => {
    applicableFromDateField.onChange(data);
  };
  const fetchdata=()=>{

    getWallet(obj.id).then((res)=>{
      if(res.status===200){
        console.log(res,"resppppppp")
        setdata(res.data)
      }
    }).catch((err)=>{
      showAlert("error", "Something went wrong");
    })
  }
  useEffect(() => {
    reset({
      // DriverType:walletMinBalance.driverSchemeName?walletMinBalance.driverSchemeName:"",
      minBalance: data?.minimumBalance,
      ServiceCity: data?.serviceCityId
        ? cityData.find(
            (element) => element.id === data?.serviceCityId
          )
        : { label: "Select Service City", value: "" },
      // applicableFromDate: selectedWallet?.applicableFromDate ? new Date(selectedWallet.applicableFromDate) : "",
      applicableFromDate: data?.applicableFrom
        ? new Date(data?.applicableFrom)
        : "",
      applicableToDate: data?.applicableTo
        ? new Date(data?.applicableTo)
        : "",
    });
  }, [data])
  

  useEffect(() => {
  
    fetchdata()
  }, [obj]);
  

  const handleWalletMinBalSubmit = (formValues) => {
    const body = {
      driverTypeId: data?.driverTypeId,
      serviceCityId: formValues.ServiceCity ? formValues.ServiceCity?.id : null,
      minimumBalance: formValues.minBalance ? formValues.minBalance : "",
      applicableFrom: new Date(formValues.applicableFromDate),
      applicableTo: new Date(formValues.applicableToDate),
      createdOn:data?.createdOn ?data?.createdOn:null,
      createdById:data?.createdById ?data?.createdById:null,
      deletedOn:data?.deletedOn ?data?.deletedOn:null,
      deletedById:data?.deletedById ?data?.deletedById :null
    };

    
      // console.log("body",driverScheme)
      // console.log("body",body)
      body["id"] = obj.id;
      updateWallet(body)
        .then((resp) => {
          closeModal()
          showAlert("success", "Updated successfully");
          triggerRefresh();
        })
        .catch((err) => {
          showAlert("error", "Something went wrong");
        });
   
  };
// ----------------------------------------------------------
  return (
    <div>
      <Form onSubmit={handleSubmit(handleWalletMinBalSubmit)}>
          <Row>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Driver Scheme</Label>
              <Col lg="12">
                <input
                  value={obj?.driverSchemeName}
                  className="form-control"
                  type="text"
                  // {...register("DriverType", {
                  //   required: {
                  //     value: true,
                  //     message: "DriverType is required",
                  //   },
                   
                  // })}
                  // readOnly
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Service City</Label>
              <Col lg="12">
                <Select
                  value={ServiceCity}
                  options={cityData}
                  {...register("ServiceCity", {
                    required: {
                      value: true,
                      message: "ServiceCity is required",
                    },
                  })}
                  placeholder={"Select Service City"}
                  onChange={(e) => setValue("ServiceCity", e)}
                  isDisabled={ServiceCity}
                />
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">
                Minimum Balance
              </Label>
              <Col lg="12">
                <input
                  value={minBalance}
                  className="form-control"
                  type="number"
                  {...register("minBalance", {
                    required: {
                      value: true,
                      message: "minBalance is required",
                    },
                    onChange: (e) => {
                      setValue("minBalance", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.minBalance?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-6">
              <Label className="col-lg-12 col-form-label">
                Applicable From
              </Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableFromDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableFromDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableFromDate?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-6">
              <Label className="col-lg-12 col-form-label">Applicable To</Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableToDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableToDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableToDate?.message}
                </span>
              </Col>
            </FormGroup>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              gap: "1rem",
            }}
          >
            {/* <button
              type="button"
              className="btn submit-button"
              onClick={() => setIsSearch(true)}
            >
              Back
            </button> */}
            <button type="submit" className="btn submit-button">
              {"Update" }
            </button>
          </div>
        </Form>
    </div>
  )
}

export default DriverSchemeMinimumEdit
